import { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import { defaultOrgsDataReceiver, defaultOrgsSelection, orgTypesFilterSelection, orgsFilter, orgsFilterSelection } from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'
import { OrgsFilterInfo } from './OrgsFilterInfo'


type Props = {
  id: string
  pending: boolean
}


export const OrgsFilter = ({ id, pending }: Props) => {
  const [isReady, setReady] = useState<boolean>(false)

  const handleOrgTypesFilter = useCallback((data: OrgType[]) => {
    if (data.length === 1) {
      orgsFilter.addDataReceiver(
        defaultOrgsDataReceiver,
      )
      orgsFilter.dataReceive()
      orgsFilter.setStatusReady()
      setReady(true)
      return
    }
    orgsFilter.resetToDefault()
    setReady(false)
  }, [])


  useEffect(() => {
    const unsubscribeOrgType = subscibeTo<OrgType[]>(orgTypesFilterSelection.id, handleOrgTypesFilter)
    return (() => {
      unsubscribeOrgType()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {isReady && <PlainItemsSelectorBox
        id={id}
        label="Заведение"
        header="Выбор заведения"
        dataBoxData={orgsFilter}
        dataBoxSelection={orgsFilterSelection}
        pleaseSelectText="Не указано"
        selectedAllOnEmptySelection={false}
        disabled={pending}
        defaultSelection={defaultOrgsSelection}
        emptyTitle="Нет данных"
      />}
      <OrgsFilterInfo />
    </>

  )
}
